import olkisirimg from '../assets/png/welcome.PNG';
import kibhoretimg from '../assets/png/Kibhoret.PNG';
import airbnbimg from '../assets/png/AirBnB.png';
import four from '../assets/svg/projects/four.svg';
import one from '../assets/svg/projects/one.svg';

export const projectsData = [
    {
        id: 1,
        projectName: 'HomeHunt',
        projectDesc: 'HomeHunt is a platform that lets tenants across Kenya browse, view, and compare rental houses by location, size, price, and amenities while enabling landlords and agents to post and manage their vacant units, digitizing the entire house-hunting journey into four simple steps: Browse, View, Compare, Rent.',
        tags: ['Web App', 'Real Estate', 'Full-Stack', 'Kenya'],
        code: 'https://www.homehunt.co.ke/',
        demo: 'https://www.homehunt.co.ke/',
        image: one
    },
    {
        id: 2,
        projectName: 'Olkisir — Dispatch & Returns System',
        projectDesc: 'Backend-led Dispatch and Returns System managing end-to-end sales order fulfillment and product return workflows. Delivers a secure API layer using Django, MySQL, and JWT authentication with Axios-driven frontend integration.',
        tags: ['Django', 'MySQL', 'JWT', 'React', 'Axios', 'REST'],
        code: 'https://github.com/Shadkoech/Webstack-Portfolio-Project',
        demo: 'https://olkisir.koech.tech',
        image: olkisirimg
    },
    {
        id: 3,
        projectName: 'Kibhoret — Material Management System',
        projectDesc: 'Full-stack Material Management System for crude palm oil tracking from port to factory, covering loading, quality control, weighbridge, and offloading checkpoints. Role-based access controls and real-time status updates.',
        tags: ['Django', 'PostgreSQL', 'Next.js', 'Tailwind', 'REST'],
        code: 'https://github.com/kibuchijw/portfolio-project/tree/Koech',
        demo: 'https://kibhoret.cellent.tech',
        image: kibhoretimg
    },
    {
        id: 4,
        projectName: 'Simple Shell (C)',
        projectDesc: 'UNIX-style command interpreter built in C with command parsing, process management, signal handling, and environment variable management.',
        tags: ['C', 'Linux', 'Bash', 'Systems Programming'],
        code: 'https://github.com/Shadkoech/simple_shell',
        demo: 'https://github.com/Shadkoech/simple_shell',
        image: four
    },
    {
        id: 5,
        projectName: 'AirBnB Clone',
        projectDesc: 'Full-stack web application replicating core AirBnB functionality: user authentication, property listings, and booking management. Built for hands-on practice with ORM and backend design.',
        tags: ['Flask', 'ORM', 'MySQL', 'HTML', 'CSS'],
        code: 'https://github.com/Shadkoech/AirBnB_clone_v3',
        demo: 'https://github.com/kibuchijw/AirBnB_clone',
        image: airbnbimg
    },
];
